module.exports = __webpack_public_path__ + "static/media/extension.ac11d2ba.jpg";